import { Container, Box } from "@mui/material"
import MenuLandingPage from "./MenuLandingPage"
import { useTheme } from "@mui/material/styles"

const Base = ({ children }) => {
    const theme = useTheme();
    return (
        <>
            <MenuLandingPage>
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        p: { xs: 1.5, sm: 2 },
                        mt: '64px',
                        minHeight: 'calc(100vh - 64px)',
                        background: theme.palette.mode === 'light' 
                            ? 'linear-gradient(to bottom, #f5f7fa 0%, #ffffff 100%)'
                            : theme.palette.background.default,
                        transition: 'background 0.3s ease',
                    }}
                >
                    <Container 
                        maxWidth="xl" 
                        sx={{
                            animation: 'fadeIn 0.5s ease-in',
                            '@keyframes fadeIn': {
                                from: {
                                    opacity: 0,
                                    transform: 'translateY(10px)',
                                },
                                to: {
                                    opacity: 1,
                                    transform: 'translateY(0)',
                                },
                            },
                        }}
                    >
                        {children}
                    </Container>
                </Box>
            </MenuLandingPage>
        </>
    )
}

export default Base